import { render } from "./AddTag.vue?vue&type=template&id=4d890120"
import script from "./AddTag.vue?vue&type=script&lang=js"
export * from "./AddTag.vue?vue&type=script&lang=js"

import "./AddTag.vue?vue&type=style&index=0&id=4d890120&lang=css"

import exportComponent from "/home/runner/work/nutristudents-k12-container/nutristudents-k12-container/.vapor/build/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__